<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="mr-auto">

      <ng-container *ngIf="canEdit">
        <button
          mat-raised-button
          class="m-1 mr-2"
          color="primary"
          matTooltip="Click this button to add a new Workflow Step Hazard/Risk."
          [matMenuTriggerFor]="linkMenu">
          <mat-icon>add</mat-icon>
          New Hazard/Risk
        </button>

        <mat-menu #linkMenu="matMenu">
          <button mat-menu-item (click)="onAdd()">
            Create New
          </button>
          <button mat-menu-item (click)="onSelectHazards()">
            Copy from {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Hazards
          </button>
          <button mat-menu-item (click)="onCopyHazards('all')">
            Copy all {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Hazards
          </button>
        </mat-menu>
      </ng-container>

      <ng-container *ngIf="canDelete">
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>
          <button mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>delete</mat-icon> Delete Selected
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Workflow Step Hazards." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </ng-container>
    </span>

    <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        aria-label="Search"
        id="search-input"
        matTooltip="Search for step hazards & risks." />

      <button
        mat-raised-button
        class="mx-0 my-1"
        color="secondary"
        id="search-button"
        type="submit"
        matTooltip="Click this button to run the current search.">
        <mat-icon>search</mat-icon>Search
      </button>
    </form>

  </nav>

  <mat-dialog-content class="m-0 py-3 px-0" style="max-height: 40vh">
    <div class="scroll-box">
      <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

      <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
            <mat-checkbox
              (change)="$event ? dataSource.selectAllToggle() : null"
              [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()" [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? dataSource.selection.toggle(row.id) : null"
              [checked]="dataSource.selection.isSelected(row.id)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            #
          </th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
            {{ ta_revised_workflow_hazard.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Name
          </th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
            <b>{{ ta_revised_workflow_hazard.name  | ellipsis: ['30'] }}</b> <br />
            <div><small style="white-space: pre-wrap">{{ ta_revised_workflow_hazard.description  | ellipsis: ['100'] }}</small></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Status
          </th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
            {{ ta_revised_workflow_hazard.status }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ira_score">
          <th mat-header-cell *matHeaderCellDef matTooltip="Initial Risk Assessment Score">IRA Score</th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(ta_revised_workflow_hazard.ira_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity))">
            {{ ta_revised_workflow_hazard.ira_score ?? utils.calculateRiskScore(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity) }}
          </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="ira">
          <th mat-header-cell *matHeaderCellDef matTooltip="Initial Risk Assessment">IRA</th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(ta_revised_workflow_hazard.ira_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity))">
            {{ ta_revised_workflow_hazard.ira_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity) }}
          </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="rra_score">
          <th mat-header-cell *matHeaderCellDef matTooltip="Residual Risk Assessment Score">RRA Score</th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(ta_revised_workflow_hazard.rra_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity))">
            {{ ta_revised_workflow_hazard.rra_score ?? utils.calculateRiskScore(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity) }}
          </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="rra">
          <th mat-header-cell *matHeaderCellDef matTooltip="Residual Risk Assessment">RRA</th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(ta_revised_workflow_hazard.rra_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity))">
            {{ ta_revised_workflow_hazard.rra_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity) }}
          </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_by_user">
          <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
            Created By
          </th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard" class="no-padding">
            <span *ngIf="ta_revised_workflow_hazard?.created_by_user else showSystemCreator">
              <a (click)="onUserPublicView(ta_revised_workflow_hazard.created_by_user.hash)"
                matTooltip="View User Public Profile">
                {{ ta_revised_workflow_hazard.created_by_user.contact_person }}
              </a>
            </span>
            <ng-template #showSystemCreator>System</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="date_created">
          <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
            Created At
          </th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard" class="no-padding">
        <span>
          {{ (ta_revised_workflow_hazard.date_created * 1000) | timezoneConvertMedium }}
        </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="date_created_UTC">
          <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
            Created At (UTC)
          </th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard" class="no-padding">
        <span>
          {{ (ta_revised_workflow_hazard.date_created * 1000) | timezoneConvertUTCMedium }}
        </span>
          </td>
        </ng-container>

        <!-- Reviewer Date Column -->
        <ng-container matColumnDef="reviewer_date">
          <th mat-header-cell *matHeaderCellDef>Review At</th>
          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
            {{ ta_revised_workflow_hazard.reviewer_date ? ((ta_revised_workflow_hazard.reviewer_date * 1000) | timezoneConvertMedium) : '' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>

          <td mat-cell *matCellDef="let ta_revised_workflow_hazard">
            <button type="button" mat-button (click)="onView(ta_revised_workflow_hazard)">
              View
            </button>

            <button type="button" mat-button (click)="onEdit(ta_revised_workflow_hazard)" *ngIf="canEdit">
              Edit
            </button>

            <button type="button" mat-button (click)="onRemove(ta_revised_workflow_hazard.id)" *ngIf="canDelete">
              Delete
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
  </mat-dialog-content>

</div>

